import { defineMessages } from 'react-intl';

type MessageKeys = 'sortAscending' | 'sortDescending';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> = defineMessages({
	sortAscending: {
		id: 'atlassian-studio-ui-components.paginated-charlie-table.sortAscending',
		defaultMessage: 'Sort ascending',
		description: 'Label for ascending sort button',
	},
	sortDescending: {
		id: 'atlassian-studio-ui-components.paginated-charlie-table.sortDescending',
		defaultMessage: 'Sort descending',
		description: 'Label for descending sort button',
	},
});

export default message;
